














import { computed, defineComponent, PropType, toRefs, watch, ref } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, CreateMode, NameTemplateType } from '@tt4b/ttam-enums';
import WcUiConfig from '@/components/common/webcomponents/wc-ui-config.vue';
import { useTagMapList } from './hooks';
import { NAME_TAG } from '../const';
import { trackEvent } from './../../../../utils/index';
import { logger } from '@tt4b/ttam-utils';
import { i18n } from './../../../../i18n';

const name = 'ttam-ad-group-template-name';
export default defineComponent({
  name,
  components: { WcUiConfig },
  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, createMode } = toRefs(props);
    const isFinishedLoadLang = ref(false);

    const nameTemplateData = computed(() => adgroupData.value.nameTemplate || {});
    const nameTemplate = computed(() => nameTemplateData.value.name_template);
    const currentPrefix = computed(() => nameTemplateData.value.prefix);
    const currentSuffix = computed(
      () => nameTemplateData.value.suffix || (!nameTemplate.value.tags.length ? props.value : ''),
    );

    // 当前选中的模板状态，从adgroupData中取。
    // 复制和编辑场景：载入页面时，调用batchQuery接口获取模板信息，初始化进adgroupData中。还有prefix sufix
    const templateInputTagInfo = computed(() => ({
      tags: nameTemplate.value.tags,
      template_id: nameTemplate.value.template_id,
      separator: nameTemplate.value.separator,
    }));
    // 用于名称模板弹窗内部感知当前选中的每个tag的对应值，从adgroupData中获取拼凑而成
    const { tagMapList } = useTagMapList(props);

    const getTagContent = tag =>
      // 如果是自定义文本的tag，直接取tag.content，否则去tagMapList取最新的对应content
      tag.type === NAME_TAG.custom_text
        ? tag.content
        : tagMapList.value.find(({ type: tagType }) => tagType === tag.type)?.content || '';

    const valueChange = data => {
      if (!data.detail) {
        logger.info('nameTemplate valueChange empty', data);
        return;
      }
      const { prefix, separator, suffix, tags, template_id, template_name } = data.detail;

      let tagsStr = tags.map(tag => getTagContent(tag)).join(` ${separator} `);
      if (Boolean(tagsStr) && Boolean(suffix)) {
        tagsStr += ' ';
      }
      emit('change', `${prefix}${tagsStr}${suffix}`);
      emit('nameTemplateChange', {
        name_template: {
          template_id,
          template_name,
          tags,
          separator,
        },
        prefix,
        suffix,
      });
    };

    const trackerHandler = ({ detail }: { detail: { trackerName: string; data: Record<string, unknown> } }) => {
      const { trackerName, data = {} } = detail || {};
      trackerName &&
        trackEvent(trackerName, {
          scence: createMode.value,
          level: 'ad group',
          objective_type: adgroupData.value.objectiveType,
          ...data,
        });
    };

    const bindParams = computed(() => ({
      currentPrefix: currentPrefix.value,
      currentSuffix: currentSuffix.value,
      templateInputTagInfo: templateInputTagInfo.value,
      tagMapList: tagMapList.value,
      type: NameTemplateType.ADGROUP,
      disabled: props.disabled,
      isTextEdit: props.disabled,
      isError: props.isError,
      disabledPrefix: true,
      placeholder: i18n.t('adgroup_name_hint'),
    }));

    const handleTagMapListChange = () => {
      // 改动adgroup层级的其他设置（如国家、语言），也需要更新adgroupData.name
      const newTags = templateInputTagInfo.value.tags.map(tag => ({
        ...tag,
        content: getTagContent(tag),
      }));
      let tagsStr = newTags.map(({ content }) => content).join(` ${templateInputTagInfo.value.separator} `);
      if (Boolean(tagsStr) && Boolean(currentSuffix.value)) {
        tagsStr += ' ';
      }

      emit('change', `${currentPrefix.value}${tagsStr}${currentSuffix.value}`);
      // 如已经正在应用tag，也需要更新adgroupData中的nameTemplate
      if (templateInputTagInfo.value.tags.length) {
        emit('nameTemplateChange', {
          name_template: {
            template_id: nameTemplate.value.template_id,
            template_name: nameTemplate.value.template_name,
            tags: newTags,
            separator: nameTemplate.value.separator,
          },
          prefix: currentPrefix.value,
          suffix: currentSuffix.value,
        });
      }
    };

    watch(
      tagMapList,
      () => {
        handleTagMapListChange();
      },
      { deep: true },
    );

    const setLangFinishedTag = () => {
      isFinishedLoadLang.value = true;
    };

    return {
      name,
      tagMapList,
      valueChange,
      trackerHandler,
      currentPrefix,
      currentSuffix,
      bindParams,
      getTagContent,
      setLangFinishedTag,
      isFinishedLoadLang,
      handleTagMapListChange,
    };
  },
});
